import LoginLayout from '@bz/account/src/routes/login/layout';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: false,
    dialog: {
      // title: () => t('login'),
      class: 'w-[860px] h-[700px]',
    },
  },
};

export default LoginLayout;
